// services/StudentProfileService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// Utilisé pour peupler les listes déroulantes (sélection d'un étudiant)
export function getStudentProfiles(params = {}) {
    return api.get(ENDPOINTS.STUDENT_PROFILES.BASE, { params });
}
export function getStudentProfileById(id) {
    return api.get(ENDPOINTS.STUDENT_PROFILES.BY_ID(id));
}
// Profil étudiant du compte actuellement connecté
export function getMyStudentProfile() {
    return api.get(`${ENDPOINTS.STUDENT_PROFILES.BASE}/me`);
}
export function createStudentProfile(payload) {
    return api.post(ENDPOINTS.STUDENT_PROFILES.BASE, payload);
}
export function updateStudentProfile(id, payload) {
    return api.patch(ENDPOINTS.STUDENT_PROFILES.BY_ID(id), payload);
}
export function deleteStudentProfile(id) {
    return api.delete(ENDPOINTS.STUDENT_PROFILES.BY_ID(id));
}
